import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {AwsServiceType} from '../../Enum/aws-service-type.enum';
import {AwsService} from '../../services/aws.service';
import {BaseClientComponent} from '../base-client.component';

@Component({
  selector: 'app-counters-mqtt',
  templateUrl: './counters-mqtt.component.html',
  styleUrls: ['./counters-mqtt.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CountersMqttComponent extends BaseClientComponent implements OnInit {
  isUserConnected = false;
  sampleDataPortsCounters: any;
  sampleDataEtreesCounters: any;
  sampleDataEtreesPlrLat: any;
  datetimeFormat = 'medium';
  etreesClientData: any;
  etreesClientDataAsString = '';
  AwsServiceType = AwsServiceType;

  constructor(
    public authenticationService: AuthenticationService,
    protected utilsService: UtilsService,
    protected http: HttpClient,
    public awsService: AwsService,
  ) {
    super()
    this.sampleDataPortsCounters = {
      'key=123479c9d419592d': {
        't': '2021-06-25T07:18:04Z',
        'rx_b': 128533,
        'rx_p': 1220,
        'rx_e_p': 0,
        'tx_b': 1459900,
        'tx_p': 22810,
        'sfp_t': '2021-06-25T07:18:04Z',
        'sp': 10,
        'rx_pow': -4.2,
        'tx_pow': -3.75
      },
      'key=1234c3b5a2b1becd': {
        't': '2021-06-25T07:18:04Z',
        'rx_b': 0,
        'rx_p': 0,
        'rx_e_p': 0,
        'tx_b': 100840,
        'tx_p': 1575,
        'sfp_t': '2021-06-25T07:18:04Z',
        'sp': 10,
        'rx_pow': -3.32,
        'tx_pow': -3.65
      }
    };
    this.sampleDataEtreesCounters = {
      'key3=45678605131e947': {
        'rx_b': 9990,
        't': '2022-03-15T13:57:03Z',
        'rx_p': 512,
        'rx_fcs_e_p': 0,
        'rx_drop_p': 39
      },
      'key3=456789f80a0b1633': {
        'rx_p': 71112,
        't': '2022-03-15T13:55:54Z',
        'rx_hc_p': 70779,
        'rx_pr_p': 70849,
        'rx_ms_e_p': 84,
        'rx_pr_e_p': 0,
        'rx_bo_e_p': 0
      },
    };
    this.sampleDataEtreesPlrLat = {
      'etree_id_1': {
        'key2=123233232323222': {
          'lat': 1000000.00,
          'plr': 0,
          'time': 1639416120
        },
        'key2=321233232323222': {
          'lat': 2000000.00,
          'plr': 10,
          'time': 1639416120
        }
      },
      'etree_id_2': {
        'key2=34563232323222': {
          'lat': 3000000.00,
          'plr': 10,
          'time': 1639416060
        }
      },
    };
  }

  async ngOnInit() {
    this.utilsService.lockUi();
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.isUserConnected = true;
      this.awsService.updateAwsParametersFromServer().then(() => {
      });
      this.utilsService.lockUi();
      this.awsService.loadEtreesForClientDisplay().subscribe(
        (response) => {
          this.etreesClientData = response;
          this.etreesClientDataAsString = JSON.stringify(this.etreesClientData);
          this.utilsService.unlockUi();
        });
    });
    this.subscriptions.push(response$);
  }

  onClickCopyEtreeData() {
    this.utilsService.displayMessage('E-Trees data copied to clipboard', '<br>');
  }

}
